import { get, post } from "../../service/api";

export const getRedisCacheTypes = async () => {
  const response = await get("/admin/redisCache/types");
  return response?.data || [];
};

export const inspectRedisCache = async (items) => {
  const response = await post("/admin/redisCache/inspect", { items }, false);
  return response;
};

export const clearRedisCache = async (items) => {
  const response = await post("/admin/redisCache/clear", { items }, false);
  return response;
};
